import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    /* const [activeSubMenu, setActiveSubMenu] = useState(null); */
   /*  const [activeMobileSubMenu, setActiveMobileSubMenu] = useState(null); */

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

   /*  const handleSubMenu = (subMenuId) => {
        setActiveSubMenu(subMenuId);
    }; */

    const handleLinkClick = () => {
        setIsMenuOpen(false);
    };

    return (
        <header id="infocolors-header" className={`is-frosted is-sticky ${isMenuOpen ? 'show-menu' : ''}`} data-appear="fade-down" data-unload="fade-up">
            <div className="infocolors-header-inner">
                <div className="infocolors-header-lp">
                    <Link to="/" className="infocolors-logo">
                        <img src="/img/logo.png" alt="infocolors." width="128" height="44" />
                    </Link>
                </div>
                <div className="infocolors-header-mp">
                    <nav className="infocolors-nav">
                        <ul className="main-menu" data-stagger-appear="fade-down" data-stagger-delay="75">
                            <li>
                                <Link to="/" onClick={handleLinkClick}>Home</Link>
                            </li>
                            <li>
                                <Link to="/about" onClick={handleLinkClick}>About Us</Link>
                            </li>
                            <li>
                                <Link to="/services" onClick={handleLinkClick}>Our Services</Link>
                            </li>
                             {/*  <li>
                                <Link to="/portfolio-slider" onClick={handleLinkClick}>Portolio</Link>
                            </li>
                          <li className="menu-item-has-children" onMouseEnter={() => handleSubMenu('pages')} onMouseLeave={() => handleSubMenu(null)}>
                                <Link to="#">Pages</Link>
                                <ul className={`sub-menu ${activeSubMenu === 'pages' ? 'is-active' : ''}`}>
                                    <li>
                                        <Link to="/services" onClick={handleLinkClick}>Our Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/service-details" onClick={handleLinkClick}>Service Details</Link>
                                    </li>
                                    <li>
                                        <Link to="/pricing" onClick={handleLinkClick}>Pricing</Link>
                                    </li>
                                </ul>
                            </li> */}
                            {/* <li className="menu-item-has-children" onMouseEnter={() => handleSubMenu('portfolio')} onMouseLeave={() => handleSubMenu(null)}>
                                <Link to="#">Portfolio</Link>
                                <ul className={`sub-menu ${activeSubMenu === 'portfolio' ? 'is-active' : ''}`}>
                                    <li>
                                        <Link to="/portfolio-slider" onClick={handleLinkClick}>Slider</Link>
                                    </li>
                                    <li>
                                        <Link to="/portfolio-post" onClick={handleLinkClick}>Portfolio Details</Link>
                                    </li>
                                </ul>
                            </li> */}
                            <li>
                                <Link to="/contact" onClick={handleLinkClick}>Contacts</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div className="infocolors-header-rp">
                    <Link to="/contact" className="infocolors-button">Let Us Create</Link>
                </div>
            </div>


            
            <div className="infocolors-mobile-header-inner">
                <Link to="/" className="infocolors-logo">
                    <img src="/img/logo.png" alt="infocolors." width="88" height="24" />
                </Link>
                <button onClick={toggleMenu} className="infocolors-mobile-menu-toggler">
                    <i className="infocolors-menu-toggler-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </i>
                </button>
            </div>
            <div className={`infocolors-mobile-menu-overlay ${isMenuOpen ? 'is-active' : ''}`} onClick={toggleMenu}></div>
            <nav className={`infocolors-mobile-nav ${isMenuOpen ? 'is-active' : ''}`}>
                <ul className="infocolors-mobile-menu">
                    <li>
                        <Link to="/" onClick={handleLinkClick}>Home</Link>
                    </li>
                    <li>
                        <Link to="/about" onClick={handleLinkClick}>About Us</Link>
                    </li>
                    <li>
                        <Link to="/services" onClick={handleLinkClick}>Our Services</Link>
                    </li>
                     {/*   <li>
                        <Link to="/portfolio-slider" onClick={handleLinkClick}>Slider</Link>
                    </li>
                    {/* <li className="menu-item-has-children" onClick={e => {
                                e.preventDefault();
                                setActiveMobileSubMenu(activeMobileSubMenu === 'pages' ? null : 'pages');
                            }} >
                        <div>Pages</div>
                        
                        <ul className={`sub-menu ${activeMobileSubMenu === 'pages' ? 'is-active' : ''}`}>
                            <li>
                                <Link to="/services" onClick={handleLinkClick}>Our Services</Link>
                            </li>
                            <li>
                                <Link to="/service-details" onClick={handleLinkClick}>Service Details</Link>
                            </li>
                            <li>
                                <Link to="/pricing" onClick={handleLinkClick}>Pricing</Link>
                            </li>
                        </ul>
                    </li>
                    <li className="menu-item-has-children" onClick={e => {
                                e.preventDefault();
                                setActiveMobileSubMenu(activeMobileSubMenu === 'portfolio' ? null : 'portfolio');
                            }}>
                        <div>Portfolio</div>
                        <ul className={`sub-menu ${activeMobileSubMenu === 'portfolio' ? 'is-active' : ''}`}>
                            <li>
                                <Link to="/portfolio-slider" onClick={handleLinkClick}>Slider</Link>
                            </li>
                            <li>
                                <Link to="/portfolio-post" onClick={handleLinkClick}>Portfolio Details</Link>
                            </li>
                        </ul>
                    </li> */}
                    <li>
                        <Link to="/contact" onClick={handleLinkClick}>Contacts</Link>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
